import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { EyebrowSm } from "storybook-components/Typography";
import { capitalizeCategoryName } from "../HelperFunctions";

const StyledEyebrow = styled(EyebrowSm)`
  margin-top: 0;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.green5};
`;

const Category = styled(Link)`
  display: block;
  text-decoration: none;
`;

export default props => {
  const { category } = props;
  const categoryLink = Array.isArray(category) ? category[0] : category;
  const formattedCategoryName = capitalizeCategoryName(category);
  /* 
    We've renamed the 'general' category to 'Mode updates'. 
    Since its burdensome to rename the ~100 general articles in contentful,
    transcribing to the display name here. 
  */
  const displayCategoryName =
    formattedCategoryName === "General"
      ? "Mode updates"
      : formattedCategoryName;
  return (
    <Category to={`/category/${categoryLink}`}>
      <StyledEyebrow className="text">{displayCategoryName}</StyledEyebrow>
    </Category>
  );
};
